import { useDispatch, useSelector } from "react-redux";
import { clearCallOffer, endCall, setActiveCall } from "../../redux/actions/callActions";
import VisioTab from "../VisioTab";
import IncomingCallOverlay from "../IncomingCallOverlay";
import { useEffect, useState } from "react";

export default function GlobalVisio({ wsRef, addCallListener, hangupCall, sendCallAccept, sendCallRequest }) {
    const dispatch = useDispatch();
    const ic = useSelector(state => state.call.incomingCall);
    const offer = useSelector(state => state.call.offer);
    const activeCall = useSelector(state => state.call.active);

    const [callInfo, setCallInfo] = useState(null);

    const acceptCall = () => {
        if (!ic) return;
        sendCallAccept(ic.matchId, ic.toUserId, ic.fromUserId);
        setCallInfo(ic);
        dispatch(setActiveCall(true));
    };

    const handleHangup = () => {
        if (!callInfo) return;
        hangupCall(callInfo.matchId, callInfo.toUserId, callInfo.fromUserId);
        dispatch(endCall());
        dispatch(clearCallOffer());
        dispatch(setActiveCall(false));
        setCallInfo(null);
    };

    useEffect(() => {
        const handleSetCallInfo = (e) => {
            setCallInfo(e.detail);
            dispatch(setActiveCall(true));
        };
        window.addEventListener("setCallInfo", handleSetCallInfo);
        return () => window.removeEventListener("setCallInfo", handleSetCallInfo);
    }, [dispatch]);

    return (
        <>
            {ic && !activeCall && (
                <IncomingCallOverlay
                    onAccept={acceptCall}
                    onDecline={handleHangup}
                />
            )}

            {callInfo && (
                <VisioTab
                    wsRef={wsRef}
                    addCallListener={addCallListener}
                    hangupCall={hangupCall}
                    fromUserId={callInfo.fromUserId}
                    toUserId={callInfo.toUserId}
                    matchId={callInfo.matchId}
                    offer={offer}
                    onHangup={handleHangup}
                    visible={true} 
                    sendCallRequest={sendCallRequest}
                />
            )}
        </>
    );
}
